import { render, staticRenderFns } from "./Tratamiento.vue?vue&type=template&id=7ee62df2"
import script from "./Tratamiento.vue?vue&type=script&lang=ts"
export * from "./Tratamiento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports